import React from 'react';

interface ExternalNavLinkProps {
  children: React.ReactNode;
  href: string;
  onClick?: (e: React.MouseEvent) => void;
}

/**
 * Component for external navigation (to Darkwing)
 * Uses special click handling for nav-bar integration.
 */
export const ExternalNavLink: React.FC<ExternalNavLinkProps> = ({ children, href, onClick }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    // Call onClick handler first (if provided)
    onClick?.(e);

    // Navigate programmatically
    window.location.href = href;
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick(e as any);
    }
  };

  return (
    <a
      href={href}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      style={{ cursor: 'pointer' }}
      role="link"
      tabIndex={0}
    >
      {children}
    </a>
  );
};
